module.exports = __webpack_public_path__ + "static/media/11.1ed9d64a.jpg";